import { createFileRoute } from "@tanstack/react-router";
import { ReportRedirect } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/r/$slug")({
  head: () => seoHead({ title: "Redirecting...", noindex: true }),
  component: ReportRedirect,
});
